/**
 * Front-end model representing a map service. See back-end complement for field descriptions.
 *
 * The following Field model attribute sets are located under the static `fields` attribute.
 * * url
 * * user
 * * pwd
 * * name
 * * server
 * * tokenUrl
 * * mainKey
 * * external
 * * defaultVisibility
 * @module app/models/MapService
 */
import Backbone from "backbone";
import _ from "underscore";
import FieldUtils from "app/utils/FieldUtils";
import urlService from "app/UrlService";
var MapService = Backbone.Model.extend(
  {
    defaults: {
      external: true,
      defaultVisibility: true,
    },

    initialize: function (attributes, options) {
      Backbone.Model.prototype.initialize.apply(this, arguments);

      this.options = _.defaults({}, options);
    },

    urlRoot: function () {
      return urlService.apiurl("/mapservice");
    },

    toJSON: function (options) {
      var json = Backbone.Model.prototype.toJSON.apply(this, arguments);

      //todo figure out what the intent of this is
      if (!json.user && !json.pwd) {
        delete json.user;
        delete json.pwd;
      }

      json.defaultVisibility = !!json.defaultVisibility;
      json.external = !!json.external;

      return json;
    },

    /**
     * Gets a value indicating whether or not this service supports exporting of data.
     * @returns {Boolean} True if export is supported, otherwise false.
     */
    canExport: function () {
      return !this.get("external");
    },

    /**
     * Gets a value indicating whether or not this layer supports exporting of data to the specified format.
     * @param {String} format The format in question. Should be one of `['kml', 'shp', 'json', 'csv', 'xls']`.
     * @returns {Boolean} True if export is supported, otherwise false.
     */
    canExportTo: function (format) {
      return format != "shp";
    },
  },
  {
    fields: {
      url: FieldUtils.fieldPrototype("url", "URL", "text"),
      user: FieldUtils.fieldPrototype("user", "User", "text"),
      pwd: FieldUtils.fieldPrototype("pwd", "Password", "password"),
      name: FieldUtils.fieldPrototype("name", "Name", "text"),
      server: FieldUtils.fieldPrototype("server", "Server", "text"),
      tokenUrl: FieldUtils.fieldPrototype("tokenUrl", "Token URL", "text"),
      mainKey: FieldUtils.fieldPrototype("mainKey", "Main Key", "text"),
      directoryKey: FieldUtils.fieldPrototype(
        "directoryKey",
        "Directory Key",
        "text"
      ),
      external: FieldUtils.fieldPrototype("external", "External?", "checkbox"),
      defaultVisibility: FieldUtils.fieldPrototype(
        "defaultVisibility",
        "Initially Visible?",
        "checkbox"
      ),
      snapshot: FieldUtils.fieldPrototype(
        "snapshot",
        "Load All At Once?",
        "checkbox"
      ),
      showLabels: FieldUtils.fieldPrototype(
        "showLabels",
        "Show Labels?",
        "checkbox"
      ),
      createdAt: FieldUtils.fieldPrototype("createdAt", "Created At", "date", {
        viewOptions: {
          type: "fromnow",
        },
        sortable: true,
      }),
      updatedAt: FieldUtils.fieldPrototype("updatedAt", "Updated At", "date", {
        viewOptions: {
          type: "fromnow",
        },
        sortable: true,
      }),
    },
  }
);

export default MapService;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/models/MapService.js
// module id = 88
// module chunks = 1